export default [
  {
    thumbnail: "/portfolio/videos/browser/Onboarding_tn.png",
    source: "/portfolio/videos/browser/Onboarding.mov",
    caption: "Onboarding"
  },
];
